import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Login2faComponent, LoginComponent, OfflineComponent, OnboadingComponent } from './components';

const routes: Routes = [
  {
    path: 'public',
    children: [
      {
        path: 'offline',
        component: OfflineComponent
      },
      {
        path: 'onboarding',
        component: OnboadingComponent
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'login/2fa',
        component: Login2faComponent
      },
      {
        path: '',
        redirectTo: '/public/login',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule {}
